/* 存放获取订单管理模块的所有axios请求 */
const axios = require('axios')
const qs = require('qs')
const { ORDER_TABLE_LIST_URL, ORDER_STATUS_CHANGE_URL, ORDER_BUSSINESS_TABLE_LIST_URL, ORDER_BUSSINESS_STATUS_CHANGE_URL } = require('./url')
const axiosHeader = require('./auth')
// const url = require('./url')

/* 获取订单管理表格列表请求 */
function getOrderTableList ({ current, size, status }) {
  return new Promise((resolve, reject) => {
    axiosHeader.axiosStop()
    axios.get(ORDER_TABLE_LIST_URL, {
      params: {
        current: current,
        size: size,
        status: status
      }
    })
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        console.log(error)
        reject(error)
      })
  })
}
/* 改变订单状态为待收货状态 */
function changeOrderStatus (id) {
  return new Promise((resolve, reject) => {
    axiosHeader.axiosStop()
    axios.put(ORDER_STATUS_CHANGE_URL, qs.stringify({
      id: id
    }))
      .then(function (response) {
        resolve(response)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/* 商户获取订单管理表格列表请求 */
function getBussinessOrderTableList ({ current, shopId, size, status }) {
  console.log(shopId)
  return new Promise((resolve, reject) => {
    axiosHeader.axiosStop()
    axios.get(`${ORDER_BUSSINESS_TABLE_LIST_URL}/${current}/${shopId}/${size}/${status}`)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/* 商户根据商品id，地址表的地址id和用户id修改订单状态 */
function changeBussinessOrderStatus (sendData) {
  return new Promise((resolve, reject) => {
    axios.put(`${ORDER_BUSSINESS_STATUS_CHANGE_URL}/${sendData.orderId}/${sendData.shippingId}/${sendData.userId}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
module.exports = {
  getOrderTableList,
  changeOrderStatus,
  getBussinessOrderTableList,
  changeBussinessOrderStatus
}
